// extracted by mini-css-extract-plugin
export default {"cuadroSolapas":"BotoneraSolapas_cuadroSolapas__PHQaX","solapa":"BotoneraSolapas_solapa__Loo3w","selected":"BotoneraSolapas_selected__8MtMV"};